/**
 * Validation for the contact a guest may leave.
 *
 * A phone number and nothing else. An e-mail field was here too, and it went:
 * points for leaving a contact are farmable with throwaway addresses in a way
 * a phone number is not.
 */

/** Digits with the punctuation people actually type, and a country prefix. */
const PHONE = /^\+?[\d\s()-]{9,}$/;

export const isValidPhone = (value: string): boolean => {
  const trimmed = value.trim();
  // Counted separately from the pattern: "+48 (12) 345" passes the shape but
  // is not a number anyone can call.
  return PHONE.test(trimmed) && trimmed.replace(/\D/g, "").length >= 9;
};
